module.exports = __webpack_public_path__ + "static/media/YamBowl4.bf65093d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Yamamoto/YamBowl4.jpg
// module id = 5773
// module chunks = 0